<template>
  <v-list class="pa-0">
    <v-list-item
      v-for="(item, index) in milks"
      :key="item.milkId || index"
      class="border-bottom"
    >
      <div class="d-flex align-center justify-space-between w-100 py-3">
        <div class="d-flex align-center">
          <p class="grey--text text--darken-1 mb-0 mr-3">
            {{ minuteFormat(item.recordedAt) }}
          </p>
          <p class="mb-0">
            {{ milkDisplayText(item) }}
          </p>
        </div>

        <v-btn
          icon
          variant="text"
          color="red"
          @click="deleteItem(item)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </div>
    </v-list-item>
  </v-list>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';
import Swal from 'sweetalert2';
import { t } from '@/i18n';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');
import { when } from '@/service/Switch';

import { dailyReportModule } from '@/store/entityModules/dailyReport';

import { MilkResponse } from '@API/src/component/home/milk/types';
/*
import {
  SwipeList,
  SwipeOut,
} from 'vue-swipe-actions';
 */
import { Toast } from '@/service/SweetAlert';
//import 'vue-swipe-actions/dist/vue-swipe-actions.css';
import { SwipeListModel } from '@/model/SwipeList/SwipeList';

export default defineComponent({

  components: {
    //SwipeOut,
    //SwipeList,
  },

  props: {
    milks: {
      type: Array,
      default: () => ([]),
    },
  },

  computed: {
    swipeList(): SwipeListModel {
      return (this.$refs as any).milk_swipe_list;
    },
  },

  methods: {
    minuteFormat(iso: string) {
      return dayjs(iso).format('HH:mm');
    },
    revealFirstRight(index, revealed) {
      if (!revealed) {
        this.swipeList.revealRight(index);
      } else {
        this.swipeList.closeActions(index);
      }
    },
    revealFirstLeft() {
      this.swipeList.revealLeft(0);
    },
    closeFirst() {
      this.swipeList.closeActions(0);
    },
    closeAll() {
      this.swipeList.closeActions();
    },
    async deleteItem(e: MilkResponse) {
      Swal.fire({
        title: `<span style="font-size: 23px;">${t('record.confirm.deleteRecord', '記録を削除しますか?')}</span>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#FF3F3A',
        cancelButtonColor: '#BDBDBD',
        confirmButtonText: t('common.delete', '削除'),
        cancelButtonText: t('common.cancel', 'キャンセル'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          Swal.showLoading();
          await dailyReportModule.deleteMilk({ milkId: e.milkId });
          Toast.fire({
            icon: 'success',
            title: t('record.toast.deleted', '削除が完了しました'),
          });
        }
      });
    },
    itemClick(e) {},
    fbClick(e) {},
    sbClick(e) {},
    milkDisplayText(item: MilkResponse): string {
      const amount = item.amount ? `${item.amount.value}cc` : t('common.unknown', '不明');
      return `${this.categoryToText(item.milkCategory)}  ${amount}`;
    },
    categoryToText(milkCategory: string): string {
      return  when(milkCategory)
        .on((v) => v === 'formula', () => t('record.status.milkFormula', 'ミルク'))
        .on((v) => v === 'breast', () => t('record.status.milkBreast', '母乳'))
        .otherwise(() => '');
    },
  },

});
</script>
<style lang="scss" scoped>

</style>
